import React, { useState, useEffect } from 'react';

import {
  ButtonGroup, ToggleButtonGroup, ToggleButton, Badge, Tooltip, Zoom, Typography, MenuItem, tooltipClasses, styled,
  Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, useMediaQuery,
  List, ListItemButton, ListItemText
} from '@mui/material';

import { useTheme } from '@mui/material/styles';

import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PersonPinCircleOutlinedIcon from '@mui/icons-material/PersonPinCircleOutlined';
import CoronavirusOutlinedIcon from '@mui/icons-material/CoronavirusOutlined';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import PrintIcon from '@mui/icons-material/Print';

import MostrarError from '../../components/AccionesPartes/MostrarError';
import AccionesPisos from '../../components/AccionesPisos/AccionesPisos';
import CargaSpinner from '../../components/AccionesPartes/CargaSpinner';
import './Pisos.css';

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(10),
    border: '1px solid #dadde9',
  },
}));

function Pisos() {
  const API_URL = 'https://api.workers.grupotel.com/';

  const fd = new FormData();
  const requestOptions = {
    method: 'POST',
    body: fd
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  //Funcion utilizada para obtener campos de AccionesPisos el hijo desde Pisos el componente Padre.
  const accionesPisosAPisos = (datos) => {
    if (datos === true) {
      actualizar();//Forzamos la actualizacion.
    }
  };
  let hoteles = localStorage.getItem('hoteles');
  const [hotelesLista, setHotelesLista] = useState([]);
  const [hotelTrabajo, setHotelTrabajo] = useState(0);

  const [habitaciones, setHabitaciones] = React.useState([]);

  //Conjunto para mostrar un Alert con el resultado de la petición
  const [mensajeError, setMensajeError] = useState('');
  const [tipoError, setTipoError] = useState('');
  const [contadorError, setContadorError] = useState(1);
  const [estadoAlert, setEstadoAlert] = React.useState(false);

  const [estadoInicial, setEstadoInicial] = React.useState(true);

  //Info para el Dialog de Pisos Hab.
  const [idHAB, setIdHAB] = React.useState('');
  const [fechaId, setFechaId] = React.useState('');
  const [limpiaHab, setLimpiaHab] = React.useState(false);
  const [bloqueadaHab, setBloqueadaHab] = React.useState(false);
  const [bloqueadaHabNombre, setBloqueadaHabNombre] = React.useState(false);

  const [mapeoHabitaciones, setMapeoHabitaciones] = React.useState("");
  const [actualizo, SetActualizo] = useState(true);

  //Boolean para mostrar o ocultar el spinner de carga
  const [contadorSpinner, setContadorSpinner] = React.useState(false);

  const [toggle, setToggle] = React.useState('estado');
  const [asignadas, setAsignadas] = React.useState([]);
  const [extras, setExtras] = React.useState([]);

  let idUsuario = localStorage.getItem('id');
  const [usuariosPisos, setUsuariosPisos] = useState([]);
  const [userPisos, setUserPisos] = useState("");

  // Control del Botón para mostrar PDF habitaciones asignadas
  const idDepartamento = localStorage.getItem('id_departamento');
  const idRol = localStorage.getItem('id_rol');
  // Verifica si el usuario tiene habitaciones asignadas
  const tieneAsignadas = asignadas.hasOwnProperty(idUsuario);
  // Verifica si es Gobernanta o IDs autorizados
  const puedeVer = (idDepartamento === '7' && idRol === '21') || ['491', '364', '91'].includes(idUsuario);
  // Mostrar botón si tiene asignadas o tiene permisos
  const mostrarBoton = tieneAsignadas || puedeVer;

  // Info Dialog mapeo habitaciones asignadas
  const [estadoAsignar, setEstadoAsignar] = React.useState(false);
  const [mapeoAsignadas, setMapeoAsignadas] = React.useState('');

  const mostrarPDF = () => {
    if (toggle === 'estado' && (idUsuario == 491 || idUsuario == 364 || idUsuario == 91 || (idDepartamento == 7 && idRol == 21))) {
      verInforme(idUsuario);
    } else if (idUsuario == 491 || idUsuario == 364 || idUsuario == 91 || (idDepartamento == 7 && idRol == 21)) { // asignado
      mostrarAsignar();
    } else { // Usuario normal, no es gobernanta
      verInforme(idUsuario);
    }
  };

  // Si es Gobernanta
  const mostrarAsignar = () => {
    const botonesUsuarios = usuariosPisos.map((usuario) => {
      const nombreMostrar = usuario.label && usuario.label.trim() !== '' ? usuario.label : 'Todos';

      return (
        <ListItemButton
          onClick={() => verInforme(usuario.value ?? null)}
          key={usuario.value ?? 'todos'}
          className="infoAsignada"
        >
          <ListItemText
            className=""
            primary={nombreMostrar}
          />
        </ListItemButton>
      );
    });

    setMapeoAsignadas(<List className='listaAsignadas'>{botonesUsuarios}</List>);
    setEstadoAsignar(true);
  };

  const comprobarESCAsignar = (event) => {
    if (event.keyCode === 27) {
      cancelAsignar();
    }
  };
  const cancelAsignar = () => {
    setMapeoAsignadas('');
    setEstadoAsignar(false);
  };

  // Edición de habitaciones asignadas
  const [modoEditar, setModoEditar] = React.useState(false);
  const [diasHab, setDiasHab] = React.useState(1);

  // Obtener los usuarios de Pisos del Hotel
  const getUsuariosPisos = async () => {
    // const fd = new FormData();
    fd.append("f", "usuarios.getList");
    fd.append("token", localStorage.getItem('token'));
    let str = "id_hotel=" + hotelTrabajo + "|id_departamento=7|";
    fd.append("params", str);

    let usuarios = [];
    usuarios.push({ value: '', label: '' });

    try {
      const response = await fetch(API_URL, requestOptions);
      const result = await response.json();

      // console.log(result)
      let error = result.error;
      if (error.id === 0) {
        delete result.error;
        Object.keys(result.usuarios).forEach((id, i) => {
          var nombreUsuario = Object.values(result.usuarios)[i].nombre;
          usuarios.push({ value: id, label: nombreUsuario });
        });
        setUsuariosPisos(usuarios.sort((a, b) => (a.label > b.label) ? 1 : -1));
        return true;
      } else if (error.id === 701) {
        setUsuariosPisos([]);
        return true;
      } else if (error.id >= 501 && error.id <= 510) {
        localStorage.setItem('token', 'CADUCADO');
        // window.location.reload();
      } else {
        setUsuariosPisos([]);
        mostrarError(error.msg);
        return false;
      }
    } catch (error) {
      setUsuariosPisos([]);
      mostrarError("Error obteniendo usuarios de Pisos.");
      return false;
    }
  };

  const habAsignadas = async () => {
    fd.append("f", "habitaciones.getHabAsignada");
    fd.append("token", localStorage.getItem('token'));
    fd.append("id_hotel", hotelTrabajo);

    try {
      const response = await fetch(API_URL, requestOptions);
      const result = await response.json();

      const error = result.error;
      if (error.id === 0) {
        const usuariosHab = result.data;
        let procesado = {};
        if (usuariosHab && typeof usuariosHab === 'object' && !Array.isArray(usuariosHab)) {
          for (const usuario in usuariosHab) {
            procesado[usuario] = usuariosHab[usuario]
              .split(',')
              .map(h => h.trim());
          }
        }
        setAsignadas(procesado);
        return procesado;
      } else if (error.id >= 501 && error.id <= 510) {
        localStorage.setItem('token', 'CADUCADO');
        window.location.reload();
      } else {
        mostrarError(error.msg);
      }
    } catch {
      mostrarError("Error obteniendo habitaciones asignadas.");
    }
    return null;
  };

  const habExtras = async () => {
    fd.append("f", "habitaciones.getHabExtras");
    fd.append("token", localStorage.getItem('token'));
    fd.append("id_hotel", hotelTrabajo);

    try {
      const response = await fetch(API_URL, requestOptions);
      const result = await response.json();
      // console.log(result);

      const error = result.error;
      if (error.id === 0) {
        setExtras(result.data);
        return result.data;
      } else if (error.id >= 501 && error.id <= 510) {
        localStorage.setItem('token', 'CADUCADO');
        window.location.reload();
      } else {
        mostrarError(error.msg);
      }
    } catch {
      mostrarError("Error obteniendo EXTRAS de las habitaciones.");
    }
    setExtras([]);
    return null;
  };

  const getRoomsHotel = async (soloHab) => {
    let asignadasData = await habAsignadas();
    if (!asignadasData) return;

    let extrasData;
    if (soloHab == 0) {
      extrasData = await habExtras();
      if (!extrasData) return;
    } else {
      extrasData = [];
      setExtras([]);
    }

    fd.append("f", "habitaciones.getRoomsHotel");
    fd.append("token", localStorage.getItem('token'));
    fd.append("id_hotel", hotelTrabajo);
    if (soloHab === 1) {
      fd.append("asignada", 1);
    }
    fetch(API_URL, requestOptions)
      .then(response => response.json(), setContadorSpinner(true))
      .then(result => {
        let error = result.error;
        if (error.id === 0) {
          // console.log(result);
          delete result.error;

          const timer2 = setTimeout(() => {
            setContadorSpinner(false);
            setHabitaciones(result);
            mapearHabitaciones(result, asignadasData, extrasData); // ← pasa directamente el valor
          }, 500);

        } else if (error.id >= 501 && error.id <= 510) {
          localStorage.setItem('token', 'CADUCADO');
          window.location.reload();
        } else {
          setContadorSpinner(false);
          mostrarError(error.msg)
        }
      })
      .catch(() => {
        setContadorSpinner(false);
        mostrarError("No se ha podido obtener las habitaciones.");
      })
  };

  const getPurguedRoomsHotel = () => {
    fd.append("f", "habitaciones.getPurguedRoomsHotel");
    fd.append("token", localStorage.getItem('token'));
    fd.append("id_hotel", hotelTrabajo);
    fetch(API_URL, requestOptions)
      .then(response => response.json(), setContadorSpinner(true))
      .then(result => {
        let error = result.error;
        if (error.id === 0) {
          //console.log(result);
          delete result.error;

          const timer2 = setTimeout(() => {
            setContadorSpinner(false);
            setHabitaciones(result);
            mapearHabitacionesPurgadas(result);
          }, 500);

        } else {
          setContadorSpinner(false);
          mostrarError(error.msg);
        }
      })
      .catch(() => {
        setContadorSpinner(false);
        mostrarError("No se ha podido obtener las habitaciones.");
      })
  };

  const mostrarError = (mensajeError, tipoError) => {
    setMensajeError(mensajeError);
    if (tipoError) {
      setTipoError(tipoError);
    } else {
      setTipoError("error");
    }
    setContadorError(contadorError + 1);
    setEstadoAlert(true);
    const timer2 = setTimeout(() => {
      setEstadoAlert(false);
    }, 3000);
    return () => clearTimeout(timer2);
  };

  const handleToggle = (event, newToggle) => {
    if (newToggle !== null) {
      setToggle(newToggle);
      setMapeoHabitaciones([]);
      actualizar();
    }
  };

  const verInforme = (idPersonalizado = null) => {
    let baseURL = "https://api.workers.grupotel.com/pdf-lib/index.php?token=workers2&action=getHabitacionesAsignadasPdf&id=";
    let final_url = baseURL + hotelTrabajo;

    if (idPersonalizado) {
      final_url += `&idUs=${idPersonalizado}`;
    }
    window.open(final_url, '_blank', 'noreferrer');
  };

  const mostrarHabitacion = (event) => {
    //Ruta para saber si el boton contiene la clase Limpia. Esto indica si la habitacion esta en true o false.
    //console.log(event.target.parentElement.classList.contains('limpia'))
    setLimpiaHab(event.target.parentElement.classList.contains('limpia'));
    setBloqueadaHab(event.target.parentElement.classList.contains('bloqueada'));
    setBloqueadaHabNombre(event.target.dataset.nombre);

    const hoy = new Date(Date.now());
    setFechaId(hoy.toUTCString());
    setIdHAB(event.target.innerText);
  };

  const asignarHabitacion = (idHab) => {
    if (modoEditar) {
      setAsignadas(prevAsignadas => {
        const nuevasAsignadas = { ...prevAsignadas };

        // Si el usuario aún no tiene ninguna habitación asignada
        if (!nuevasAsignadas[userPisos]) {
          nuevasAsignadas[userPisos] = [];
        }

        // Si ya la tiene asignada, la quitamos
        if (nuevasAsignadas[userPisos].includes(idHab)) {
          nuevasAsignadas[userPisos] = nuevasAsignadas[userPisos].filter(h => h !== idHab);
        } else {
          // Si no la tiene, la añadimos
          nuevasAsignadas[userPisos].push(idHab);
        }
        // console.log(nuevasAsignadas);
        return nuevasAsignadas;
      });
    }
  };

  const asignarUsuarioHab = async () => {
    setModoEditar(false);

    if (!userPisos || !hotelTrabajo) {
      mostrarError("Faltan datos obligatorios (usuario u hotel).");
      return;
    }

    if (!(userPisos in asignadas)) {
      mostrarError("No hay cambios que guardar.");
      return;
    }

    const habsUsuario = asignadas[userPisos];

    fd.append("f", "habitaciones.setHabAsignada");
    fd.append("token", localStorage.getItem('token'));
    fd.append("id_hotel", hotelTrabajo);
    fd.append("id_us", userPisos);
    fd.append("habs", (habsUsuario && habsUsuario.length > 0) ? habsUsuario.join(",") : "0");
    fd.append("dias", diasHab);

    fetch(API_URL, requestOptions)
      .then(response => response.json(), setContadorSpinner(true))
      .then(result => {
        let error = result.error;

        const timer2 = setTimeout(() => {
          setContadorSpinner(false);
          if (error.id === 0) {
            // console.log(result);
            mostrarError("Asignación guardada correctamente.", "success");
            setModoEditar(false);
            actualizar();
          } else {
            console.log(error);
            mostrarError(error.msg);
          }
        }, 500);

      })
      .catch(() => {
        setContadorSpinner(false);
        mostrarError("No se ha podido asignar las habitaciones.")
      })
  };

  const mapearHabitaciones = (result, asignadasData, extrasData) => {

    const asignadasMap = asignadasData || asignadas;
    const extrasMap = extrasData || extras;

    let estructura = [];
    let estructura2 = [];
    let hab = [];
    let hab2 = [];

    let habitaciones = result;
    setMapeoHabitaciones('');

    // console.log(usuariosPisos)

    if (Object.keys(habitaciones).length === 0) {
      estructura.push(
        <div className='noEncontrado'>{"No se ha podido encontrar Información."}
          <ErrorOutlineIcon className='icon-button-Editar ' />
        </div>
      );
      setMapeoHabitaciones(estructura);
    } else {
      let contador = 1;
      Object.keys(habitaciones).map((idBloque) => {
        //Si contador es impar
        if ((contador % 2) !== 0) {
          estructura.push(
            <div><h3 className='tituloBloque'>{habitaciones[idBloque].bloque}</h3></div>
          );
        } else {
          estructura2.push(
            <div><h3 className='tituloBloque'>{habitaciones[idBloque].bloque}</h3></div>
          );
        }

        let bloque = habitaciones[idBloque]
        Object.keys(bloque).map((idPlanta) => {
          if (idPlanta !== "bloque" && idPlanta !== "id_bloque") {
            hab = [];
            hab2 = [];

            let planta = bloque[idPlanta]
            Object.keys(planta).map((idHab) => {
              let asignadoA = Object.keys(asignadasMap).find(userId =>
                asignadasMap[userId]?.includes(idHab)
              );

              let usuarioNombre = '';

              // if (usuariosPisos.length > 0) {
              const userObj = usuariosPisos.find(user => String(user.value) === String(asignadoA));
              usuarioNombre = userObj ? userObj.label : '';
              // }
              // console.log(usuarioNombre)

              const esDelUsuario = asignadoA === userPisos;
              const estaAsignada = !!asignadoA;
              // Deshabilitamos el botón si ya esta asignada a otro usuario. Y si no estamos en modo editar
              const deshabilitado = estaAsignada && !esDelUsuario && !modoEditar && toggle === 'asignado';

              // Asignar clases visuales
              let claseExtra = '';
              if (toggle === 'asignado') {
                if (esDelUsuario) claseExtra = 'asignada-propia';
                else if (estaAsignada) claseExtra = 'asignada-otro';
              }

              let tmp = 'juntar';
              let estadoHabitacion = habitaciones[idBloque][idPlanta][idHab]['limpia'];
              let bloqueadaHabitacion = habitaciones[idBloque][idPlanta][idHab]['bloqueada'];
              let usuarioBloqueadorHabitacion = habitaciones[idBloque][idPlanta][idHab]['nombre'];
              switch (estadoHabitacion) {
                case 1:
                  tmp = 'juntar limpia';
                  break;
                case 2:
                  tmp = 'juntar noMolestar';
                  break;
                case 3:
                case 4:
                case 5:
                  // tmp = 'juntar bloqueada';
                  break;
                case 6:
                  tmp = 'juntar colorSalida';
                  break;
                case 7:
                  tmp = 'juntar colorSalidaHoy';
                  break;
              }
              if (bloqueadaHabitacion == 1) {
                tmp = tmp + " bloqueada";
              }

              // Comprobamos si el usuario tiene la habitación asiganada
              if (asignadasMap[idUsuario]?.includes(idHab) && toggle != 'asignado') {
                tmp = tmp + " bordeAsignado";
              }

              let npartes = habitaciones[idBloque][idPlanta][idHab]['partes'];
              // Comprobamos si hay extras en la habitación
              let infoPartes;
              let clasePastilla = '';

              if (extrasMap[idHab] && npartes >= 1) {
                const numExtras = Object.keys(extrasMap[idHab]).length;

                // console.log("Hay extra en esta hab")

                // console.log(extrasMap[idHab])
                infoPartes = (
                  <span style={{ display: "flex", gap: "8px" }}>
                    <span>{npartes} </span> <span> {numExtras}</span>
                  </span>
                );
                clasePastilla = 'toolPartes';
              } else if (extrasMap[idHab] && npartes == 0) {
                const numExtras = Object.keys(extrasMap[idHab]).length;

                infoPartes = (
                  <div >
                    <span> {numExtras}</span>
                  </div>
                );
                clasePastilla = 'divBadgeExtra';
              } else {
                infoPartes = (
                  <div>
                    <span>{npartes}</span>
                  </div>
                );
                clasePastilla = 'divBadgeParte';
              }

              const tooltipLines = [];
              if (npartes > 0) {
                tooltipLines.push("Partes abiertos: " + npartes);
              }
              if (extrasMap[idHab]) {
                const numExtras = Object.keys(extrasMap[idHab]).length;
                tooltipLines.push("Extras: " + numExtras);
              }

              if ((contador % 2) !== 0) {
                if (npartes >= 1 || extrasMap[idHab]) {
                  hab.push(
                    <HtmlTooltip
                      placement="top-start" enterDelay={0} leaveDelay={100}
                      title={
                        <React.Fragment>
                          {tooltipLines.map((line, idx) => (
                            <Typography key={idx} color="inherit">{line}</Typography>
                          ))}
                        </React.Fragment>
                      }
                    >
                      <Badge badgeContent={infoPartes}
                        className={clasePastilla}
                        sx={{ maxWidth: "max-content" }}>
                        <Button
                          className={`${tmp} ${claseExtra}`}
                          disabled={toggle === 'asignado' && deshabilitado}
                          onClick={(event) => {
                            if (toggle === 'asignado' && !deshabilitado) {
                              asignarHabitacion(idHab);
                            } else if (toggle !== 'asignado') {
                              mostrarHabitacion(event);
                            }
                          }}
                        >
                          <span data-nombre={usuarioBloqueadorHabitacion} className='hab-texto'>{idHab}</span>
                        </Button>
                      </Badge>
                    </HtmlTooltip>
                  );
                } else {
                  const button = (
                    <span>
                      <Button
                        className={`${tmp} ${claseExtra}`}
                        disabled={toggle === 'asignado' && deshabilitado}
                        onClick={(event) => {
                          if (toggle === 'asignado' && !deshabilitado) {
                            asignarHabitacion(idHab);
                          } else if (toggle !== 'asignado') {
                            mostrarHabitacion(event);
                          }
                        }}
                      >
                        <span data-nombre={usuarioBloqueadorHabitacion} className='hab-texto'>{idHab}</span>
                      </Button>
                    </span>
                  );
                  if (toggle === 'asignado' && usuarioNombre) {
                    hab.push(
                      <HtmlTooltip
                        placement="top-start"
                        enterDelay={0}
                        leaveDelay={100}
                        title={
                          <React.Fragment>
                            <Typography color="inherit">{usuarioNombre}</Typography>
                          </React.Fragment>
                        }
                      >
                        {button}
                      </HtmlTooltip>
                    );
                  } else {
                    hab.push(button);
                  }
                }
              } else {
                if (npartes >= 1 || extrasMap[idHab]) {
                  hab2.push(
                    <HtmlTooltip
                      placement="top-start" enterDelay={0} leaveDelay={100} TransitionComponent={Zoom}
                      title={
                        <React.Fragment>
                          {tooltipLines.map((line, idx) => (
                            <Typography key={idx} color="inherit">{line}</Typography>
                          ))}
                        </React.Fragment>
                      }
                    >
                      <Badge badgeContent={infoPartes}
                        className={clasePastilla}
                        sx={{ maxWidth: "min-content" }}>
                        <Button
                          className={`${tmp} ${claseExtra}`}
                          disabled={toggle === 'asignado' && deshabilitado}
                          onClick={(event) => {
                            if (toggle === 'asignado' && !deshabilitado) {
                              asignarHabitacion(idHab);
                            } else if (toggle !== 'asignado') {
                              mostrarHabitacion(event);
                            }
                          }}
                        >
                          <span data-nombre={usuarioBloqueadorHabitacion} className='hab-texto'>{idHab}</span>
                        </Button>
                      </Badge>
                    </HtmlTooltip>
                  );
                } else {
                  const button = (
                    <span>
                      <Button
                        className={`${tmp} ${claseExtra}`}
                        disabled={toggle === 'asignado' && deshabilitado}
                        onClick={(event) => {
                          if (toggle === 'asignado' && !deshabilitado) {
                            asignarHabitacion(idHab);
                          } else if (toggle !== 'asignado') {
                            mostrarHabitacion(event);
                          }
                        }}
                      >
                        <span data-nombre={usuarioBloqueadorHabitacion} className='hab-texto'>{idHab}</span>
                      </Button>
                    </span>
                  );
                  if (toggle === 'asignado' && usuarioNombre) {
                    hab2.push(
                      <HtmlTooltip
                        placement="top-start"
                        enterDelay={0}
                        leaveDelay={100}
                        title={
                          <React.Fragment>
                            <Typography color="inherit">{usuarioNombre}</Typography>
                          </React.Fragment>
                        }
                      >
                        {button}
                      </HtmlTooltip>
                    );
                  } else {
                    hab2.push(button);
                  }
                }
              }
            })
            // console.log("Bloque y Planta: " + idBloque + " " + idPlanta);
            if ((contador % 2) !== 0) {
              estructura.push(
                <div className='piso-bloque' id={"bloque_" + contador}>
                  <ListItemText className='planta'
                    key={idBloque.toString() + "_" + idPlanta.toString() + "_" + habitaciones[idBloque].bloque}
                    value={idBloque + "_" + idPlanta}
                  >
                    {"P" + idPlanta}
                  </ListItemText>
                  <div className='hab'>
                    {hab}
                  </div>
                </div>
              );
            } else {
              estructura2.push(
                <div className='piso-bloque' id={"bloque_" + contador}>
                  <ListItemText className='planta'
                    key={idBloque.toString() + "_" + idPlanta.toString() + "_" + habitaciones[idBloque].bloque}
                    value={idBloque + "_" + idPlanta}
                  >
                    {"P" + idPlanta}
                  </ListItemText>
                  <div className='hab'>
                    {hab2}
                  </div>
                </div>
              );
            }
          }
        })
        if (estructura2) {
          setMapeoHabitaciones(<div className='pisosContainer'><div className='pisosLeft'>{estructura}</div> <div className='pisosLeft'>{estructura2}</div></div>)
        } else {
          setMapeoHabitaciones(<div className='pisosLeft'>{estructura}</div>);
        }
        contador++;
      })
    }
  };

  const mapearHabitacionesPurgadas = (result) => {
    let estructura = [];
    let estructura2 = [];
    let hab = [];
    let hab2 = [];

    let habitaciones = result;
    setMapeoHabitaciones('');

    if (Object.keys(habitaciones).length === 0) {
      estructura.push(
        <div className='noEncontrado'>{"No se ha podido encontrar Información."}
          <ErrorOutlineIcon className='icon-button-Editar ' />
        </div>
      );
      setMapeoHabitaciones(estructura);

    } else {
      let contador = 1;
      Object.keys(habitaciones).map((idBloque) => {
        //Si contador es impar
        if ((contador % 2) !== 0) {
          estructura.push(
            <div><h3 className='tituloBloque'>{habitaciones[idBloque].bloque}</h3></div>
          );
        } else {
          estructura2.push(
            <div><h3 className='tituloBloque'>{habitaciones[idBloque].bloque}</h3></div>
          );
        }

        let bloque = habitaciones[idBloque];
        Object.keys(bloque).map((idPlanta) => {
          if (idPlanta !== "bloque" && idPlanta !== "id_bloque") {
            hab = [];
            hab2 = [];

            let planta = bloque[idPlanta];
            Object.keys(planta).map((idHab) => {
              let tmp = 'juntar';

              let bloqueadaHabitacion = habitaciones[idBloque][idPlanta][idHab]['bloqueada'];
              let purgadaHabitacion = habitaciones[idBloque][idPlanta][idHab]['purgada'];
              let usuarioBloqueadorHabitacion = habitaciones[idBloque][idPlanta][idHab]['nombre'];
              if (bloqueadaHabitacion == 1) {
                tmp = tmp + " bloqueada";
              }
              switch (purgadaHabitacion) {
                case 1:
                  tmp = tmp + " sin-purgar";
                  break;
                case 2:
                  tmp = tmp + " purgada";
                  break;
                default:
                  break;
              }
              let npartes = habitaciones[idBloque][idPlanta][idHab]['partes'];
              if ((contador % 2) !== 0) {
                if (npartes >= 1) {
                  hab.push(
                    <HtmlTooltip
                      placement="top-start" enterDelay={0} leaveDelay={100}
                      title={
                        <React.Fragment>
                          <Typography color="inherit">{"Partes Abiertos: " + npartes}</Typography>
                        </React.Fragment>
                      }
                    >
                      <Badge badgeContent={npartes}
                        // color="warning"
                        sx={{ maxWidth: "max-content" }}>
                        <Button className={tmp} onClick={mostrarHabitacion} >
                          <span data-nombre={usuarioBloqueadorHabitacion} className='hab-texto'>{idHab}</span>
                        </Button>
                      </Badge>
                    </HtmlTooltip>
                  );
                } else {
                  hab.push(
                    <Badge badgeContent={npartes}
                      // color="warning"
                      sx={{ maxWidth: "max-content" }}>
                      <Button className={tmp} onClick={mostrarHabitacion} >
                        <span data-nombre={usuarioBloqueadorHabitacion} className='hab-texto'>{idHab}</span>
                      </Button>
                    </Badge>
                  );
                }
              } else {
                if (npartes >= 1) {
                  hab2.push(
                    <HtmlTooltip
                      placement="top-start" enterDelay={0} leaveDelay={100} TransitionComponent={Zoom}
                      title={
                        <React.Fragment>
                          <Typography color="inherit">{"Partes Abiertos: " + npartes}</Typography>
                        </React.Fragment>
                      }
                    >
                      <Badge badgeContent={npartes}
                        // color="warning"
                        sx={{ maxWidth: "min-content" }}>
                        <Button className={tmp} onClick={mostrarHabitacion} >
                          <span data-nombre={usuarioBloqueadorHabitacion} className='hab-texto'>{idHab}</span>
                        </Button>
                      </Badge>
                    </HtmlTooltip>
                  );
                } else {
                  hab2.push(
                    <Button className={tmp} onClick={mostrarHabitacion} >
                      <span data-nombre={usuarioBloqueadorHabitacion} className='hab-texto'>{idHab}</span>
                    </Button>
                  );
                }
              }
            })
            if ((contador % 2) !== 0) {
              estructura.push(
                <div className='piso-bloque'>
                  <ListItemText className='planta'
                    key={idBloque.toString() + "_" + idPlanta.toString()}
                    value={idBloque + "_" + idPlanta}
                  >
                    {"P" + idPlanta}
                  </ListItemText>
                  <div className='hab'>
                    {hab}
                  </div>
                </div>
              );
              //                  {"Planta: " + idPlanta}
            } else {
              estructura2.push(
                <div className='piso-bloque'>
                  <ListItemText className='planta'
                    key={idBloque.toString() + "_" + idPlanta.toString()}
                    value={idBloque + "_" + idPlanta}
                  >
                    {"P" + idPlanta}
                  </ListItemText>
                  <div className='hab'>
                    {hab2}
                  </div>
                </div>
              );
            }
          }
        })
        if (estructura2) {
          setMapeoHabitaciones(<div className='pisosContainer'><div className='pisosLeft'>{estructura}</div> <div className='pisosLeft'>{estructura2}</div></div>);
        } else {
          setMapeoHabitaciones(<div className='pisosLeft'>{estructura}</div>);
        }
        contador++;
      })
    }
  };

  const cambiaHotelTrabajo = (event) => {
    if (event.target.name === 'id_hotel') {
      setHotelTrabajo(event.target.value);
    }
  };
  const actualizar = () => {
    SetActualizo(!actualizo);
  };

  const cargarDatos = async () => {
    const success = await getUsuariosPisos();
    if (!success) return;

    if (toggle === 'estado') {
      getRoomsHotel(0);
    } else if (toggle === 'ocupacion') {
      getPurguedRoomsHotel();
    } else if (toggle === 'asignado') {
      getRoomsHotel(1);
    }
  };

  useEffect(() => {
    let listaHoteles = JSON.parse(hoteles);
    setHotelesLista(listaHoteles);

    if (estadoInicial) {
      let idHotel = localStorage.getItem('idHotelSeleccionado');
      if (idHotel) {
        setHotelTrabajo(idHotel);
        setEstadoInicial(false);
      } else {
        console.log(listaHoteles);
      }
    }
  }, [estadoInicial]);

  useEffect(() => {
    if (hotelTrabajo !== 0) {
      cargarDatos();
    } else {
      setAsignadas([]);
      setMapeoHabitaciones([
        <div className='noEncontrado'>
          {"No hay ningún hotel seleccionado."}
          <ErrorOutlineIcon className='icon-button-Editar ' />
        </div>
      ]);
    }

    if (toggle !== 'asignado') {
      const interval = setInterval(() => {
        actualizar();
      }, 5 * 60 * 1000);

      return () => clearInterval(interval);
    }
  }, [hotelTrabajo, actualizo]);

  useEffect(() => {
    if (habitaciones && Object.keys(habitaciones).length > 0) {
      mapearHabitaciones(habitaciones, asignadas, extras);
    }
  }, [asignadas, userPisos, modoEditar]);

  return (
    <>
      <div className='container'>
        <div className='content' style={{ "height": "70px" }}>
          <div className='article'>
            <div className='header'>
              <div className='containerAcciones contenidoIzquierda'>
                <ButtonGroup className="botonera" variant="contained" aria-label="outlined button group">
                  <HtmlTooltip
                    placement="bottom" enterDelay={500} leaveDelay={200} TransitionComponent={Zoom}
                    title={
                      <React.Fragment>
                        <Typography color="inherit">{"Actualizar"}</Typography>
                      </React.Fragment>
                    }
                  >
                    <Button
                      className="boton"
                      onClick={actualizar}
                    >
                      <RotateLeftIcon className='icon-button' />
                    </Button>
                  </HtmlTooltip>
                  <HtmlTooltip
                    placement="bottom" enterDelay={500} leaveDelay={200} TransitionComponent={Zoom}
                    title={
                      <React.Fragment>
                        {toggle === 'estado' || toggle === 'asignado' ?
                          <div className='ayuda-container'>
                            <div className='color-container'>
                              <div className='color pendiente'></div>
                              <Typography color="inherit">{"Pendiente"}</Typography>
                            </div>
                            <div className='color-container'>
                              <div className='color limpia'></div>
                              <Typography color="inherit">{"Limpia"}</Typography>
                            </div>
                            <div className='color-container'>
                              <div className='color noMolestar'></div>
                              <Typography color="inherit">{"No molestar"}</Typography>
                            </div>
                            <div className='color-container'>
                              <div className='color bloqueada'></div>
                              <Typography color="inherit">{"Bloqueada"}</Typography>
                            </div>
                            <div className='color-container'>
                              <div className='color colorSalida'></div>
                              <Typography color="inherit">{"Salida"}</Typography>
                            </div>
                            <div className='color-container'>
                              <div className='color colorSalidaHoy'></div>
                              <Typography color="inherit">{"Sale hoy"}</Typography>
                            </div>
                            <hr></hr>
                            <div className='color-container'>
                              <div className='color colorHabAsignada'></div>
                              <Typography color="inherit">{"Hab. Asignada"}</Typography>
                            </div>
                          </div>
                          :
                          <div className='ayuda-container'>
                            <div className='color-container'>
                              <div className='color pendiente'></div>
                              <Typography color="inherit">{"Sin necesidad"}</Typography>
                            </div>
                            <div className='color-container'>
                              <div className='color limpia'></div>
                              <Typography color="inherit">{"Purgada"}</Typography>

                            </div>
                            <div className='color-container'>
                              <div className='color colorSalida'></div>
                              <Typography color="inherit">{"Sin purgar"}</Typography>
                            </div>
                          </div>
                        }
                      </React.Fragment>
                    }
                  >
                    <Button
                      className="boton"
                    >
                      <InfoOutlinedIcon className='icon-button' />
                    </Button>
                  </HtmlTooltip>
                  <div className='separador'></div>
                  <ToggleButtonGroup
                    className="botonera" aria-label="outlined button group"
                    value={toggle}
                    exclusive
                    onChange={handleToggle}
                  >
                    <HtmlTooltip
                      placement="bottom" enterDelay={500} leaveDelay={200} TransitionComponent={Zoom}
                      title={
                        <React.Fragment>
                          <Typography color="inherit">{"Mapa de habitaciones"}</Typography>
                        </React.Fragment>
                      }
                    >
                      <ToggleButton className={toggle === 'estado' ? 'boton pintado' : 'boton'} size='small' value="estado" aria-label="Estado">
                        <PersonPinCircleOutlinedIcon className='icon-button'></PersonPinCircleOutlinedIcon>
                      </ToggleButton>
                    </HtmlTooltip>

                    <HtmlTooltip
                      placement="bottom" enterDelay={500} leaveDelay={200} TransitionComponent={Zoom}
                      title={
                        <React.Fragment>
                          <Typography color="inherit">{"Legionella / Purgaciones"}</Typography>
                        </React.Fragment>
                      }
                    >
                      <ToggleButton className={toggle === 'ocupacion' ? 'boton pintado' : 'boton'} size='small' value="ocupacion" aria-label="Ocupacion">
                        <CoronavirusOutlinedIcon className='icon-button'></CoronavirusOutlinedIcon>
                      </ToggleButton>
                    </HtmlTooltip>
                    {
                      localStorage.getItem('id') == 491 || localStorage.getItem('id') == 364 || localStorage.getItem('id') == 91 || (localStorage.getItem('id_departamento') == 7 && localStorage.getItem('id_rol') == 21) ?
                        // (localStorage.getItem('id_departamento') == 7 && localStorage.getItem('id_rol') == 21) // Pisos y gobernanta
                        <HtmlTooltip
                          placement="bottom" enterDelay={500} leaveDelay={200} TransitionComponent={Zoom}
                          title={
                            <React.Fragment>
                              <Typography color="inherit">{"Asignar Habitaciones"}</Typography>
                            </React.Fragment>
                          }
                        >
                          <ToggleButton className={toggle === 'asignado' ? 'boton pintado' : 'boton'} size='small' value="asignado" aria-label="Asignado">
                            <AssignmentIndIcon className='icon-button' />
                          </ToggleButton>
                        </HtmlTooltip>
                        : ""
                    }
                  </ToggleButtonGroup>
                </ButtonGroup>
              </div>
            </div>
          </div>
          <div className='aside' >
            <div className='header'>
              {(toggle === 'estado' || toggle === 'asignado') && (
                <div className='containerAcciones'>
                  <ButtonGroup className="botonera" variant="contained" aria-label="outlined button group">
                    {mostrarBoton && (
                      <HtmlTooltip
                        placement="bottom"
                        enterDelay={500}
                        leaveDelay={200}
                        TransitionComponent={Zoom}
                        title={
                          <React.Fragment>
                            <Typography color="inherit">{"Habitaciones Asignadas"}</Typography>
                          </React.Fragment>
                        }
                      >
                        <Button
                          className="boton"
                          onClick={(e) => {
                            e.stopPropagation();
                            mostrarPDF();
                          }}
                        >
                          <PrintIcon className="icon-button" />
                        </Button>
                      </HtmlTooltip>
                    )}
                  </ButtonGroup>

                  <TextField
                    className='fifty'
                    variant="outlined"
                    margin="normal"
                    label="Hotel"
                    name="id_hotel"
                    size="small"
                    value={hotelTrabajo ? hotelTrabajo : ""}
                    onChange={cambiaHotelTrabajo}
                    select
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          sx: { maxHeight: { sm: 36 * 8 + 8 } }
                        }
                      }
                    }}
                  >
                    {hotelesLista.map((hotel) => (
                      <MenuItem key={hotel.value} value={hotel.value} >
                        {hotel.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
              )}
              {toggle != 'estado' && toggle != 'asignado' && (
                <TextField
                  className='fifty'
                  variant="outlined"
                  margin="normal"
                  label="Hotel"
                  name="id_hotel"
                  size="small"
                  value={hotelTrabajo ? hotelTrabajo : ""}
                  onChange={cambiaHotelTrabajo}
                  select
                  SelectProps={{
                    MenuProps: {
                      PaperProps: {
                        sx: { maxHeight: { sm: 36 * 8 + 8 } }
                      }
                    }
                  }}
                >
                  {hotelesLista.map((hotel) => (
                    <MenuItem key={hotel.value} value={hotel.value} >
                      {hotel.label}
                    </MenuItem>
                  ))}
                </TextField>
              )}

            </div>
          </div>
        </div>

        {toggle === 'asignado' && (
          <div className='content' style={{ height: "70px" }}>
            <div className='article'>
              <div className='header containerAsignar'>
                <TextField
                  className='fifty'
                  variant="outlined"
                  margin="normal"
                  label="Usuario"
                  name="id_user"
                  size="small"
                  value={userPisos || ""}
                  onChange={(ev) => setUserPisos(ev.target.value)}
                  select
                  SelectProps={{
                    MenuProps: {
                      PaperProps: {
                        sx: { maxHeight: { sm: 36 * 8 + 8 } }
                      }
                    }
                  }}
                >
                  {usuariosPisos.map((user) => (
                    <MenuItem key={user.value} value={user.value}>
                      {user.label}
                    </MenuItem>
                  ))}
                </TextField>

                <div className='divSelectAsignar'>
                  {!modoEditar ? (
                    <>
                    </>
                  ) : (
                    <TextField
                      label="Días"
                      variant="outlined"
                      margin="normal"
                      size="small"
                      className='sinMargenIzq'
                      value={diasHab}
                      onChange={(ev) => setDiasHab(Number(ev.target.value))}
                      select
                      sx={{ minWidth: 100, ml: 2 }}
                    >
                      {[...Array(31)].map((_, index) => (
                        <MenuItem key={index + 1} value={index + 1}>
                          {index + 1}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                </div>
              </div>
            </div>
            <div className='aside' id="containerAsignar">
              <div className='header containerButtonAsignar'>
                <div className='divButtonAsignar'>
                  {!modoEditar ? (
                    <Button
                      variant="outlined"
                      disabled={!userPisos}
                      onClick={() => setModoEditar(true)}
                      sx={{ ml: 2 }}
                    >
                      Editar
                    </Button>
                  ) : (
                    <>
                      <ButtonGroup className="botonera sinShadow" variant="contained">
                        <Button
                          className="colorGrupo"
                          onClick={() => {
                            asignarUsuarioHab();
                          }}
                        // sx={{ ml: 2 }}
                        >
                          Guardar
                        </Button>
                        <Button
                          className="colorGrupo borrarBoton"
                          onClick={() => {
                            setModoEditar(false);
                            actualizar();
                          }}
                          sx={{ ml: 1 }}
                        >
                          Cancelar
                        </Button>
                      </ButtonGroup>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        <div className='full-width'>{mapeoHabitaciones}</div>

        <Dialog fullScreen={fullScreen}
          open={estadoAsignar}
          onClose={comprobarESCAsignar}
          aria-labelledby="responsive-dialog-title" id="dialogMostrarAsignadas">
          <DialogTitle>Mapas habitaciones asignadas y extras </DialogTitle>
          <DialogContent>
            <div className='infoPartesHab'>
              {mapeoAsignadas}
            </div>
          </DialogContent>
          <DialogActions>
            <ButtonGroup className="botonera" variant="contained" aria-label="outlined button group">
              <Button className="colorGrupo borrarBoton" onClick={cancelAsignar}>Cancelar</Button>
            </ButtonGroup>
          </DialogActions>
        </Dialog>

        <AccionesPisos idHab={idHAB} idHotel={hotelTrabajo} fechaId={fechaId} limpiaHab={limpiaHab} bloqueadaHab={bloqueadaHab} accionesPisosAPisos={accionesPisosAPisos} bloqueadaHabNombre={bloqueadaHabNombre} />
        <CargaSpinner contadorSpinner={contadorSpinner} />
        <MostrarError mensajeEr={mensajeError} tipoError={tipoError} contadorError={contadorError} estadoAlert={estadoAlert} />
      </div>
    </>
  );
}
export default Pisos;
